import Controller from '@ember/controller';
import type TeamModel from 'scaleflow/models/team';

export default class OperationsTeamsTeamHomeController extends Controller {
  declare model: TeamModel;
}
